// Keep only the account fields needed for navigation in browser storage.
// Two shapes: a cookie session, where the API holds an httpOnly cookie and we
// keep the user and CSRF token in localStorage so every tab stays signed in for
// the cookie's 7 days; or the legacy bearer token in sessionStorage, used when
// login answers without a csrfToken (a backend that predates cookie sessions).
const ROLES = ['superadmin', 'doctor', 'labadmin'];

export function clearSession() {
  for (const storage of [localStorage, sessionStorage]) {
    for (const key of ['token', 'user', 'userId', 'viewingLab', 'csrfToken']) storage.removeItem(key);
  }
}

export function getSession() {
  try {
    const token = sessionStorage.getItem('token');
    const csrfToken = localStorage.getItem('csrfToken');
    const user = JSON.parse((token ? sessionStorage : localStorage).getItem('user') || 'null');
    if ((!token && !csrfToken) || !user?._id || !ROLES.includes(user.role)) return null;
    return token ? { token, user } : { csrfToken, user };
  } catch { return null; }
}

export function saveSession(token, user, csrfToken) {
  if ((!token && !csrfToken) || !user?._id || !ROLES.includes(user.role)) {
    throw new Error('This account does not have dashboard access.');
  }
  if (user.role === 'doctor' && user.doctorApprovalStatus && user.doctorApprovalStatus !== 'approved') {
    throw new Error('Your doctor account is awaiting approval. Open the doctor app to view or complete your application.');
  }
  clearSession();
  const storage = csrfToken ? localStorage : sessionStorage;
  if (csrfToken) localStorage.setItem('csrfToken', csrfToken);
  else sessionStorage.setItem('token', token);
  storage.setItem('user', JSON.stringify({ _id: user._id, name: user.name, role: user.role, labId: user.labId }));
}

export function homeFor(user) {
  return user.role === 'superadmin' ? '/superadmin' : `/${user.role === 'doctor' ? 'doctor' : 'lab'}/${user._id}`;
}
